import { render, staticRenderFns } from "./NozamaOrderDetail.vue?vue&type=template&id=f7b71d34&scoped=true"
import script from "./NozamaOrderDetail.vue?vue&type=script&lang=js"
export * from "./NozamaOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./NozamaOrderDetail.vue?vue&type=style&index=0&id=f7b71d34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7b71d34",
  null
  
)

export default component.exports